const config = {
  env: 'production',
  inFrame: true,
  settingsUrl: '',
};

const deferredMethods = [
  'hideInvite',
  'version',
  'commitHash',
  'showChat',
  'hideChat',
  'onHideChat',
  'onScenarios',
  'onLoad',
  'on',
  'reInit',
];

function callWhenReady(method, args) {
  const interval = window.setInterval(() => {
    if (window.ThreadsWidget && !window.ThreadsWidget.isDummy) {
      window.clearInterval(interval);
      window.ThreadsWidget?.[method]?.(...args);
    }
  }, 100);
}

function createWidgetApiStub() {
  window.ThreadsWidget = { isDummy: true };

  deferredMethods.forEach(method => {
    window.ThreadsWidget[method] = (...args) => callWhenReady(method, args);
  });
}

function loadWidgetBundle(settings, options) {
  if (!settings.webchat || !settings.filename) {
    console.error('[vue-edna-chat] Invalid widget settings');
    return;
  }

  settings.webchat.filename = settings.filename;

  if (typeof options.locale === 'string') {
    settings.webchat.currentLocale = options.locale;
  }

  if (typeof options.unavailable === 'boolean') {
    settings.webchat.isUnavailableOnStart = options.unavailable;
  }

  try {
    sessionStorage.setItem('__threadsWidget', JSON.stringify(settings.webchat));
  } catch (error) {
    window.__threadsWidget = JSON.stringify(settings.webchat);
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = settings.filename;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.body.appendChild(script);
  }
}

function loadWidget(settingsUrl, options) {
  const request = new XMLHttpRequest();

  request.onreadystatechange = function () {
    if (request.readyState !== XMLHttpRequest.DONE) return;

    if (request.status === 200) {
      loadWidgetBundle(JSON.parse(request.responseText), options);
    } else {
      console.error(`[vue-edna-chat] Failed to load widget settings: ${request.status}`);
    }
  };

  request.open('GET', `${settingsUrl}?rnd=${Math.random()}`);
  request.send();
}

export default function install(Vue, options = {}) {
  const resolvedOptions = { ...config, ...options };
  const isTopLevelPage = window.self === window.top;
  const shouldLoad = resolvedOptions.env === 'production' && (resolvedOptions.inFrame || isTopLevelPage);

  if (!shouldLoad) {
    console.warn('[vue-edna-chat] Widget is disabled outside production or inside an iframe');
    return;
  }

  if (!resolvedOptions.settingsUrl) {
    console.error('[vue-edna-chat] settingsUrl is required');
    return;
  }

  createWidgetApiStub();

  const initialize = () => loadWidget(resolvedOptions.settingsUrl, resolvedOptions);
  if (document.readyState === 'complete') {
    initialize();
  } else {
    window.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
}
